import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Stack, Shimmer, ShimmerElementType } from '@fluentui/react';

function getShimmerGroups(count) {
  const labelElement = [
    { type: ShimmerElementType.line, height: 16 },
  ];

  const inputElement = [
    { type: ShimmerElementType.line, height: 32 },
  ];

  return (
    <Stack tokens={{ childrenGap: 20 }}>
      {
        _.range(count).map(ele => (
          <Stack tokens={{ childrenGap: 8 }} className="shimmer-wrapper" key={`shimmer-${ele}`}>
            <Shimmer width="20%" shimmerElements={labelElement} className="label-shimmer" />
            <Shimmer width="75%" shimmerElements={inputElement} className="input-shimmer" />
          </Stack>
        ))
      }
    </Stack>
  );
}

export const SectionShimmer = ({
  count,
  isDataLoaded,
  children,
}) => (
  <>
    <div className={classNames({ hidden: !isDataLoaded })}>
      {children}
    </div>
    {!isDataLoaded && getShimmerGroups(count)}
  </>
);

SectionShimmer.propTypes = {
  count: PropTypes.number.isRequired,
  isDataLoaded: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};
